const userInfo = {
  email: '',
  avatarUrl: '',
  valido: false
}

export default userInfo;
